import axios from "axios";
import {API_BASE_URL} from "@/api/axios";

const apiNoToken = axios.create({
    baseURL: API_BASE_URL,
});
export function getTranslationsApi(lang) {
    const params = {group:4}
    return apiNoToken.get(`/translations/${lang}`, {params})
}


